module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs7": "",
      "sm8": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v(_vm._s(_vm.section.heading))]), _vm._v(" "), (_vm.section.body) ? _c('p', {
    staticClass: "static-info--sub-teaser",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs5": "",
      "sm4": "",
      "text-right": ""
    }
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.button_text) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.additional_button_text) + "\n                ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bb2a0ec","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/heading/heading.vue
// module id = 625
// module chunks = 0